import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-lg-6" }, [
      /*#__PURE__*/_createVNode("h1", { class: "title" }, "template")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-lg-6" }, [
      /*#__PURE__*/_createVNode("div", { class: "button-header text-right" }, [
        /*#__PURE__*/_createVNode("a", {
          href: "javascript:void(0)",
          class: "btn default-btn d-inline-block"
        }, [
          /*#__PURE__*/_createVNode("svg", {
            class: "svg-inline--fa fa-plus fa-w-14",
            "aria-hidden": "true",
            focusable: "false",
            "data-prefix": "fas",
            "data-icon": "plus",
            role: "img",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            "data-fa-i2svg": ""
          }, [
            /*#__PURE__*/_createVNode("path", {
              fill: "currentColor",
              d: "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
            })
          ]),
          /*#__PURE__*/_createTextVNode(" Create template")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("div", { class: "table-responsive my-3" }, [
    /*#__PURE__*/_createVNode("table", { class: "table table-bordered table-shadowed mb-0" }, [
      /*#__PURE__*/_createVNode("thead", { class: "table-primary" }, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("th", { scope: "col" }, "template name"),
          /*#__PURE__*/_createVNode("th", { scope: "col" }, "created on"),
          /*#__PURE__*/_createVNode("th", { scope: "col" }, "created by"),
          /*#__PURE__*/_createVNode("th", { scope: "col" }, "Action")
        ])
      ]),
      /*#__PURE__*/_createVNode("tbody", null, [
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "painter template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn view-btn mr-1"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn edit-btn mr-1"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn send-btn mr-1",
                "data-toggle": "modal",
                "data-target": "#sendtemplate"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn delete-btn mr-0"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "people template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn default-btn outline"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn default-btn outline secondary"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn default-btn outline orange"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn default-btn outline danger"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "deadline template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn default-btn outline"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn default-btn outline secondary"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn default-btn outline orange"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn default-btn outline danger"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "material template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn default-btn outline"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn default-btn outline secondary"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn default-btn outline orange"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn default-btn outline danger"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "basic information template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn default-btn outline"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn default-btn outline secondary"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn default-btn outline orange"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn default-btn outline danger"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createVNode("tr", null, [
          /*#__PURE__*/_createVNode("td", null, "gardener template"),
          /*#__PURE__*/_createVNode("td", null, "12-10-2020"),
          /*#__PURE__*/_createVNode("td", null, "Abhishek KC"),
          /*#__PURE__*/_createVNode("td", null, [
            /*#__PURE__*/_createVNode("div", { class: "table-button" }, [
              /*#__PURE__*/_createVNode("a", {
                title: "View",
                href: "#",
                class: "btn default-btn outline"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-eye" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Edit",
                href: "#",
                class: "btn default-btn outline secondary"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-pen" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Send to",
                href: "#",
                class: "btn default-btn outline orange"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-long-arrow-alt-right" })
              ]),
              /*#__PURE__*/_createVNode("a", {
                title: "Delete",
                href: "#",
                class: "btn default-btn outline danger"
              }, [
                /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" })
              ])
            ])
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createVNode("nav", { "aria-label": "Page navigation example" }, [
    /*#__PURE__*/_createVNode("ul", { class: "pagination" }, [
      /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "page-link",
          href: "#"
        }, "Previous")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "page-link",
          href: "#"
        }, "1")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "page-link",
          href: "#"
        }, "2")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "page-link",
          href: "#"
        }, "3")
      ]),
      /*#__PURE__*/_createVNode("li", { class: "page-item" }, [
        /*#__PURE__*/_createVNode("a", {
          class: "page-link",
          href: "#"
        }, "Next")
      ])
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-wrap\"><div class=\"modal fade\" id=\"sendtemplate\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" id=\"exampleModalLabel\">Send template</h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">×</span></button></div><div class=\"modal-body\"><div class=\"form-wrap pt-0\"><div class=\"form-group\"><label for=\"\">Select channels to send template</label><input type=\"text\" class=\"form-control\" placeholder=\"Select channels to send template\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn secondary-btn\" data-dismiss=\"modal\"> Close </button><button type=\"button\" class=\"btn default-btn\">send</button></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2
  ]))
}